import React, { createContext, useContext, useState, useEffect } from 'react';

// Creazione del Context
const AuthContext = createContext();

// Provider Component che avvolgerà la nostra app
export const AuthProvider = ({ children }) => {
  // State per memorizzare i dati dell'utente
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Effetto per verificare se l'utente è già loggato all'avvio dell'app
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  // Funzione per gestire il login
  const login = (userData) => {
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
  };

  // Funzione per gestire il logout
  const logout = () => {
    localStorage.removeItem('user');
    setUser(null);

    localStorage.clear(); // Per sicurezza
  };

  // Funzioni helper per verificare tutti i tipi di ruolo
  const isAdmin = () => {
    return user?.roles?.includes('ROLE_ADMIN') || false;
  };

  const isModerator = () => {
    return user?.roles?.includes('ROLE_MODERATOR') || false;
  };

  const isUser = () => {
    return user?.roles?.includes('ROLE_USER') || false;
  };

  const isSchool = () => {
    return user?.roles?.includes('ROLE_SCHOOL') || false;
  };

  const isHostingPartner = () => {
    return user?.roles?.includes('ROLE_HOSTING_PARTNER') || false;
  };

  // Funzione per verificare se l'utente ha almeno uno dei ruoli specificati
  const hasAnyRole = (roles) => {
    if (!user || !user.roles) return false;
    return roles.some(role => user.roles.includes(role));
  };

  // Funzione per verificare se l'utente ha tutti i ruoli specificati
  const hasAllRoles = (roles) => {
    if (!user || !user.roles) return false;
    return roles.every(role => user.roles.includes(role));
  };

  // Valori che saranno disponibili attraverso il Context
  const value = {
    user,
    login,
    logout,
    isAdmin,
    isModerator,
    isUser,
    isSchool,
    isHostingPartner,
    hasAnyRole,
    hasAllRoles,
    loading,
    // Esponiamo valori individuali per compatibilità con il codice esistente
    token: user?.accessToken,
    idUtente: user?.id,
    ruolo: user?.roles?.[0], // Mantiene compatibilità con il codice esistente che aspetta un singolo ruolo
    roles: user?.roles || [], // Esponiamo anche l'array completo dei ruoli
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

// Hook personalizzato per usare il Context dell'autenticazione
export const useAuth = () => useContext(AuthContext);